import {selectCardById} from 'state/card/cardSelectors';
import {isPublicationGroup} from 'utilities/URL';
import get from 'lodash/get';

export const selectIsChartPickerActive = state =>
  state.cardDetail.isChartPickerActive;

export const selectIsFilterActive = state => state.cardDetail.isFilterActive;

export const selectIsTableActive = state => state.cardDetail.isTableActive;

const BADGE_TYPES = new Set(['kpi', 'drill_view']);

const isBadge = card => BADGE_TYPES.has(get(card, ['type']));

const isKPI = card => get(card, ['type']) === 'kpi';

const isDomoApp = card => get(card, ['type']) === 'domoapp';

const isTextWithDataSources = card =>
  get(card, ['type']) === 'Text' && get(card, ['datasources', 'length']) > 0;

const isTable = card =>
  get(card, ['metadata', 'chartType'], '').endsWith('_table');

const isMap = card => get(card, ['metadata', 'chartType'], '').includes('_map');

const isSuperTable = card => get(card, ['type']) === 'supertable';

export const selectIsMap = (state, cardId) => {
  const card = selectCardById(state, cardId);
  return isMap(card);
};

export const selectIsSuperTable = (state, cardId) =>
  isSuperTable(selectCardById(state, cardId));

const selectProbablyHasChartPicker = (state, cardId) => {
  const card = selectCardById(state, cardId);

  return isBadge(card) && !isTable(card) && !isMap(card);
};

export const selectHasChartPicker = (state, cardId) =>
  get(
    state.cardDetail.cardFeatures[cardId],
    'isChartPickerAvailable',
    selectProbablyHasChartPicker(state, cardId)
  );

export const selectHasTable = (state, cardId) => {
  const card = selectCardById(state, cardId);
  return isBadge(card) && !isTable(card);
};

export const selectHasFilters = (state, cardId) => {
  const card = selectCardById(state, cardId);
  return isKPI(card) || isDomoApp(card) || isTextWithDataSources(card);
};

export const selectHasSaveAs = (state, cardId) => {
  const card = selectCardById(state, cardId);
  return !isPublicationGroup(cardId) && !isDomoApp(card);
};

export const selectHasExport = (state, cardId) => {
  const card = selectCardById(state, cardId);
  return isBadge(card) || isTable(card);
};
